import { formatSummaryFeature } from '~app/pages/Pricing/lib/PackageFeatures';
import { SETTING_UNLIMITED } from '~app/pages/Pricing/transformers/summary/rules/featureRules';
import { SummaryFeatureRuleMap } from '~app/pages/Pricing/transformers/summary/types';
import { Packages } from '~shared/constants/pricing';
import { DisplayFeatureStatic } from '~shared/types/pricing/features';

const FeatureRules: SummaryFeatureRuleMap = {
  // Add feature rule overrides below
  grow_2792_user: (_, { packageName }) => {
    let obj: DisplayFeatureStatic = formatSummaryFeature('grow_2792_single_user');

    if (packageName) {
      if (
        [Packages.AdvantageAnnual, Packages.TeamAdvantage, Packages.PremierAnnual, Packages.TeamPremier].includes(
          packageName
        )
      ) {
        obj = formatSummaryFeature('grow_2792_team_collaboration_user');
      }

      if ([Packages.Enterprise].includes(packageName)) {
        obj = formatSummaryFeature('grow_2792_advanced_team_collaboration_user');
      }
    }

    return obj;
  },
  grow_2792_survey_create_limit: ({ survey_create_limit, create_question_limit }) => {
    let obj: DisplayFeatureStatic = {};

    if (survey_create_limit?.setting === SETTING_UNLIMITED) {
      obj = formatSummaryFeature('grow_2792_survey_create_limit');
    } else if (create_question_limit?.setting === SETTING_UNLIMITED) {
      obj = formatSummaryFeature('create_question_limit');
    }

    return obj;
  },
  unlimited_questions: () => {
    return formatSummaryFeature('grow_2792_unlimited_questions');
  },
  grow_2792_question_types: (_, { packageName }) => {
    return formatSummaryFeature(
      packageName && [Packages.FormsAnnual, Packages.FormsMonthly].includes(packageName)
        ? 'grow_2792_forms_question_types'
        : 'grow_2792_all_question_types'
    );
  },
  support: () => formatSummaryFeature('priority_email_support'),
  grow_2792_analyze_export_enabled: () => formatSummaryFeature('grow_2792_analyze_export_enabled'),
  grow_2792_website_embed: () => formatSummaryFeature('grow_2792_website_embed'),
  grow_2792_zapier_integrations: () => formatSummaryFeature('grow_2792_zapier_integrations'),
  skip_logic: () => formatSummaryFeature('grow_2792_skip_logic'),
  grow_2792_survey_branding: (_, { packageName }) => {
    return formatSummaryFeature(
      packageName && [Packages.FormsAnnual, Packages.FormsMonthly].includes(packageName)
        ? 'grow_2792_create_custom_theme_enabled'
        : 'survey_branding'
    );
  },
  grow_2792_text_analysis: () => formatSummaryFeature('grow_2792_text_analysis'),
  grow_2792_multilingual: () => formatSummaryFeature('multilingual'),
  grow_2792_a_b_testing: () => formatSummaryFeature('grow_2792_a_b_testing'),
};

export default FeatureRules;
